export default __webpack_public_path__ + "static/media/V720_D_BD.b746d395.pdf";